// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--5-1!../../../postcss-loader/lib/index.js??ref--5-2!../../../px2rem-loader/index.js??ref--5-3!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("39918149", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/swipe/index.css
// module id = JsOw
// module chunks = 170